/* unplugin-vue-components disabled */import script from "./Gm.vue?vue&type=script&setup=true&lang=js"
export * from "./Gm.vue?vue&type=script&setup=true&lang=js"

import "./Gm.vue?vue&type=style&index=0&id=4e319e6f&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e319e6f"]])

export default __exports__